import { create } from 'zustand'
import { CameraMode } from '@constants/names'
import { SlotType } from '@modules/inventory/store/avatar.store'

export interface CameraState {
  lerping: boolean
  cameraMode: CameraMode
  setLerping: (v: boolean) => void
  setCameraMode: (slot: SlotType) => void
}

const toCameraMode = (slotType: SlotType): CameraMode => {
  switch (slotType) {
    case SlotType.Eyes:
    case SlotType.Eyewear:
    case SlotType.Eyebrows:
    case SlotType.FacialHair: {
      return CameraMode.Face
    }

    case SlotType.Headwear:
    case SlotType.Hair: {
      return CameraMode.Head
    }

    case SlotType.Tops:
    case SlotType.Outerwear: {
      return CameraMode.Top
    }

    case SlotType.Legwear: {
      return CameraMode.Bottom
    }

    case SlotType.Footwear:
    case SlotType.Socks: {
      return CameraMode.Feet
    }

    default: {
      return CameraMode.Free
    }
  }
}

export const useCameraStorage = create<CameraState>()((set) => ({
  cameraMode: CameraMode.Free,
  lerping: false,
  setCameraMode: (slot) =>
    set({
      cameraMode: toCameraMode(slot)
    }),
  setLerping: (v) =>
    set({
      lerping: v
    })
}))
